import Papa from 'papaparse'
import Alpine from 'alpinejs'
import Chart, { Tooltip } from 'chart.js/auto'
import zoomPlugin from 'chartjs-plugin-zoom'

// Import HTMX and extensions
// We do this separately to ensure import order
import './extensions-init'
import './htmx-init'

// Import Alpine components
import './components'

// Initialise Alpine
Alpine.start()

// Close navbar dropdowns when clicking outside
document.addEventListener('click', (event) => {
  const navbar = document.querySelector('.navbar')
  if (!navbar) return

  // Handle desktop dropdowns
  const detailsElements = navbar.querySelectorAll('details')
  const clickedSummary = event.target.closest('summary')
  
  detailsElements.forEach((details) => {
    if (details.hasAttribute('open')) {
      // Close if clicking outside this details element
      // Or if clicking on a different summary (to allow switching between dropdowns)
      const isClickingThisSummary = clickedSummary && clickedSummary.parentElement === details
      
      if (!isClickingThisSummary && !details.contains(event.target)) {
        details.removeAttribute('open')
      }
    }
  })

  // Handle mobile dropdown (DaisyUI dropdown)
  // DaisyUI dropdowns close on blur, but we ensure it works by removing focus
  const dropdown = navbar.querySelector('.dropdown')
  if (dropdown) {
    const dropdownButton = dropdown.querySelector('[role="button"]')
    
    // Check if dropdown button has focus (indicating dropdown is open)
    if (dropdownButton && document.activeElement === dropdownButton) {
      // Check if the click is outside the dropdown
      if (!dropdown.contains(event.target)) {
        dropdownButton.blur()
      }
    }
  }
})

// Set default Chart.js options
Chart.register(zoomPlugin)
Chart.defaults.plugins.legend.align = 'end'
Chart.defaults.plugins.legend.labels.boxWidth = 10
Chart.defaults.plugins.legend.labels.usePointStyle = true
Chart.defaults.plugins.legend.labels.pointStyle = 'rectRounded'
Chart.defaults.plugins.legend.onClick = function (e, legendItem, legend) {
  const chart = legend.chart
  const index = legendItem.datasetIndex
  const isShiftPressed = e.native.shiftKey

  if (isShiftPressed) {
    // If Shift is pressed, toggle visibility of the clicked dataset only
    const meta = chart.getDatasetMeta(index)
    meta.hidden = meta.hidden === null ? true : null
  } else {
    // If Shift is not pressed, isolate the clicked dataset or unhide all
    const allOthersHidden = chart.data.datasets.every((dataset, i) => {
      const meta = chart.getDatasetMeta(i)
      return i === index ? !meta.hidden : meta.hidden
    })

    if (allOthersHidden) {
      // Unhide all datasets
      chart.data.datasets.forEach((dataset, i) => {
        const meta = chart.getDatasetMeta(i)
        meta.hidden = null
      })
    } else {
      // Hide all datasets except the clicked one
      chart.data.datasets.forEach((dataset, i) => {
        const meta = chart.getDatasetMeta(i)
        meta.hidden = i === index ? null : true
      })
    }
  }

  chart.update() // Update the chart to reflect changes
}
Tooltip.positioners.customPosition = function (elements, eventPosition) {
  const chartWidth = this.chart.width
  const midPoint = chartWidth / 2 + this.chart.chartArea.left
  const isLeftSide = eventPosition.x < midPoint
  return {
    x: isLeftSide ? this.chart.chartArea.right - 10 : this.chart.chartArea.left + 10,
    y: eventPosition.y
  }
}

export { Papa }
